export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLCz7Z1JlFc-K-cbf6a43847d3a94a6d6bda69ab73d3be.woff2";